import { Component ,Input,EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent {
  @Input() PData: any;
  @Output()emitPass: EventEmitter<any> = new EventEmitter<any>();
  constructor(
  ) { }

 
commonMethod(){
  this.emitPass.emit();
}
}
